import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext.jsx";
import Navbar from "./componeds/header/Navbar";
import ImageSlider from "./componeds/Slider/ImageSlider";
import BestSellingProduct from "./componeds/bestseller/BestSellingProduct.js";
import AdSlider from "./componeds/adslider/AdSlider.js";
import Footer from "./componeds/footer/Footer.js";
import Testimonials from "./componeds/feedback/Testimonials.js";
import CategorySlider from "./componeds/CategorySlider/CategorySlider.js";
import ProductSection from "./componeds/ProductSection/ProductSection.js";
import CategoryProducts from "./componeds/CategorySlider/CategoryProducts.js";
import ProductDetailPage from "./componeds/productdatails/ProductDetailPage.js";
import CartPage from "./componeds/Cartpage/CartPage.js";
import PrivacyPolicy from "./componeds/PrivacyPolicy/Privacypolicy.js"
import TermsService from "./componeds/PrivacyPolicy/TermsService.js"
import { useEffect, useState } from "react";
// import MyOrdersPage from "./componeds/MyCartPage/MyOrdersPage.js";
// import AboutUs from "./componeds/Aboutsection/AboutUs.js";
// import TopOffers from "./componeds/topofferssection/TopOffers.js";
// import { ToastContainer, toast } from 'react-toastify';
import { CartProvider } from './context/CartContext';
import Myorder from "./componeds/MyCartPage/MyOrdersPage.js"
import Chatwidget from "./Chatwidget.js";
// import MyOrdersPage from "./componeds/MyCartPage/MyOrdersPage.jsx";
import AboutUs from './componeds/Aboutsection/AboutUs.js'
import Contact from './componeds/Contactsection/Contact.jsx'
import ScrollTotop from "./ScrollTotop.js";
import Features from "./componeds/Features.js";
import Loader from "./Loader.js";
import Faq from "./componeds/footer/Faq.js";
import SearchResultPage from "./componeds/ProductSection/SearchResultPage.js";
function App() {
  const [searchTerm, setSearchTerm] = useState("");
  const [loader, setLoader] = useState(true);
  console.log({ Navbar, ImageSlider, BestSellingProduct, AdSlider, Footer, Testimonials, CategorySlider, ProductSection, ProductDetailPage });
  useEffect(() => {
    const timer = setTimeout(() => setLoader(false), 1000);
    return () => clearTimeout(timer);
  }, [])
  if (loader) {
    return <Loader />
  }
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollTotop />
          <div className="app-container">
            <Navbar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              products={[]}
              getImageUrl={(path) => path}
            />
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <ImageSlider />
                    <CategorySlider />
                    {/* <AboutUs/> */}
                    <ProductSection searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
                    {/* <TopOffers/> */}
                    <AdSlider />
                    <BestSellingProduct />
                    <Testimonials />
                    <Features />
                  </>
                }
              />
              <Route path="/address" element={<CartPage initialStep="address" />} />
              <Route path="/category/:categoryId" element={<CategoryProducts searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/products/:productId" element={<ProductDetailPage />} />
              <Route path="/search" element={<SearchResultPage searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsService />} />
              <Route path="/myorder" element={<Myorder />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/faq" element={<Faq />} />
            </Routes>
            <Chatwidget />
            <Footer />
            {/* <ToastContainer position="top-right" autoClose={3000} /> */}
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;